import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';
import {Headers, Http} from '@angular/http';
import {UvmApi} from './uvm.api';
import {map} from 'rxjs/operators';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class LoginService {

  public login = new Subject<any>();
  private uvmApi: UvmApi;

  constructor(private http: Http) {
    this.uvmApi = UvmApi.Singleton;
  }

  get(user: String, psw: String) {
    let headers: Headers;
    headers = this.uvmApi.headers;
    headers.append('AuthenticationType', 'Applicant');
    headers.append('System', 'UVM');
    return this.http
      .post((this.uvmApi.url + '/auth/1.0/salesforce/token?username=' + user + '&password=' + psw), null, {headers})
      .pipe(
        map(res => res.json()));
  }

  getCommunityUser(user: String, psw: String) {
    return this.http
      .post(( environment.loginApiUrl + 'username=' + user + '&password=' + psw), null)
      .pipe(
        map(res => res.json()));
  }

  updateCache(value) {
    this.login.next(value);
  }
}
